import { Reducer } from 'redux';
import {
  setBlogGalleryFiles,
  SET_BLOG_GALLERY_FILES,
  SET_BLOG_GALLERY_FILES_MOBILE,
} from '../actions/blogActions';

type Action =
  | ReturnType<typeof setBlogGalleryFiles>
  | { type: 'OTHER_ACTION'; payload?: any };

const initialState = {
  galleryFilesMobile: Array<File>(),
  galleryFiles: Array<File>(),
};
const blogReducer: Reducer<any, Action> = (
  previousState = initialState,
  action
) => {
  // if (action.type === SET_GALLERY_IMAGES) {
  //   previousState.galleryImages = action.payload
  // }
  // if (action.type === SET_GALLERY_IMAGES_MOBILE) {
  //   previousState.galleryImagesMobile = action.payload
  // }
  if (action.type === SET_BLOG_GALLERY_FILES) {
    previousState.galleryFiles = action.payload;
  }
  if (action.type === SET_BLOG_GALLERY_FILES_MOBILE) {
    previousState.galleryFilesMobile = action.payload;
  }

  return previousState;
};

export default blogReducer;
